<ng-container [formGroup]="addressFormGroup">
  <!-- row -->
  <div class="row">

    <!-- autocomplete -->
    <div class="col-12" *ngIf="!isDemo">
      <address-autocomplete (onSelectAddress)="updateAddress($event)" [tabNum]="blockIndex" *ngIf="!disabled"></address-autocomplete>
    </div>
    <!-- /autocomplete -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">      
        <div class="demo-overlay" *ngIf="isDemo"></div>
        <label for="street-autocomplete" class="visually-hidden">Street</label>
        <input id="street-autocomplete" type="text" class="form-control" formControlName="Street" maxlength="36" placeholder="Street Address" tabindex="0" [ngClass]="{'input-required': isRequired && !isDemo}">
        <error-messages [form]="parent" [field]="formGroupParent + '.Street'" skipFeedback="true"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12 col-md-4">
      <div class="form-group">
        <div class="demo-overlay" *ngIf="isDemo"></div>
        <label for="street2-autocomplete" class="visually-hidden">Street2</label>
        <input id="street2-autocomplete" type="text" class="form-control" formControlName="Street2" maxlength="36" placeholder="Apartment/Unit" tabindex="0">
        <error-messages [form]="parent" [field]="formGroupParent + '.Street2'" skipFeedback="true"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12 col-md-8">
      <div class="form-group">
        <div class="demo-overlay" *ngIf="isDemo"></div>
        <label for="city-autocomplete" class="visually-hidden">City</label>
        <input id="city-autocomplete" type="text" class="form-control" formControlName="City" maxlength="23" placeholder="City" tabindex="0" [ngClass]="{'input-required': isRequired && !isDemo}">
        <error-messages [form]="parent" [field]="formGroupParent + '.City'" skipFeedback="true">
        </error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12 col-md-4">
      <div class="form-group">
        <div class="select-wrapper">
          <label for="state-autocomplete" class="visually-hidden">State</label>
          <select class="form-control" id="state-autocomplete" formControlName="State" tabindex="0" [ngClass]="{'input-required': isRequired}">
            <option [ngValue]="null" label="State" selected="selected" disabled></option>
            <option *ngFor="let opt of states" [value]="opt.key">
              {{ opt.value }}
            </option>
          </select>
        </div>
        <error-messages [form]="parent" [field]="formGroupParent + '.State'" skipFeedback="true"></error-messages>
    </div>
  </div>
  <!-- /item -->

  <!-- item -->
  <div class="col-12 col-md-8">
    <div class="form-group">
      <label for="zip-autocomplete" class="visually-hidden">Zip</label>
      <input id="zip-autocomplete" type="text" class="form-control" formControlName="Zip" placeholder="Zip Code" oninput="this.value=this.value.replace(/(?![0-9])./gmi,'')" maxlength="5" tabindex="0" [ngClass]="{'input-required': isRequired}">
      <error-messages [form]="parent" [field]="formGroupParent + '.Zip'" skipFeedback="true">
      </error-messages>
    </div>
  </div>
  <!-- /item -->
  </div><!-- /row -->

</ng-container>
